import React from 'react';
import { Skeleton } from 'antd';

export default function LandingPage() {
  
  return (
   <>
   <div>
   <Skeleton />
   </div>
   </>
  );
}
